<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.returns'), $t('text.create')]"
      ></breadcrumb>
      <div class="container">
        <el-form ref="formObjForm" :model="formObj" size="small">
          <div class="pd20">
            <fieldset class="mgb15">
              <legend>{{ $t("text.baseInfo") }}</legend>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    label-width="80px"
                    :label="$t('returnedMaterial.serialNo')"
                    :prop="'serialNo'"
                    :rules="[
                      {
                        required: true,
                        validator: validateSerialNo,
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input size="small" v-model.trim="formObj.serialNo" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label-width="80px"
                    :label="$t('menu.suppliers')"
                    :prop="'supplierId'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('menu.suppliers')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-select
                      size="small"
                      v-model.trim="formObj.supplierId"
                      filterable
                      clearable
                    >
                      <el-option
                        v-for="supplier in suppliers"
                        :key="supplier.id"
                        :label="supplier.name"
                        :value="supplier.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('text.remark')"
                    :prop="'remark'"
                    label-width="60px"
                  >
                    <el-input size="small" v-model.trim="formObj.remark" />
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset class="mgb15">
              <legend>{{ $t("menu.materials") }}</legend>
              <div
                class="flex flex-between mgb10"
                v-for="(item, index) in formObj.items"
                :key="index"
              >
                <div class="mgr10">
                  <upload-single-picture v-model="item._image" />
                </div>
                <div class="flex-grow">
                  <el-row :gutter="10">
                    <el-col :span="19">
                      <el-row :gutter="10">
                        <el-col :span="6">
                          <el-form-item>
                            <el-autocomplete
                              size="small"
                              v-model="item.materialSerialNo"
                              style="width: 100%"
                              :placeholder="
                                $t('rules.mustFill', [
                                  $t('material.serialNoName'),
                                ])
                              "
                              :fetch-suggestions="querySearchSerialNo"
                              @select="handleSelectSerialNo(index)"
                            >
                            </el-autocomplete>
                            <small v-if="item._localRepeatFg" class="red">{{
                              $t("rules.filledIn", [$t("material.serialNo")])
                            }}</small>
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item>
                            <el-input
                              v-model="item.materialName"
                              :placeholder="$t('material.name')"
                              :disabled="item.inventoryId !== null"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="4">
                          <el-form-item>
                            <el-input
                              v-model="item.subjectName"
                              :placeholder="$t('material.subject')"
                              :disabled="item.inventoryId !== null"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="4">
                          <el-form-item>
                            <el-input
                              v-model="item.color"
                              :placeholder="$t('material.color')"
                              :disabled="item.inventoryId !== null"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="4">
                          <el-form-item>
                            <el-input
                              v-model="item.colorNo"
                              :placeholder="$t('material.colorNo')"
                              :disabled="item.inventoryId !== null"
                            />
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="10">
                        <el-col :span="6">
                          <el-form-item>
                            <el-input
                              size="small"
                              v-model.trim="item.quantity"
                              :placeholder="
                                $t('rules.mustFill', [$t('text.quantity')])
                              "
                            >
                              <template slot="append">{{ item.unit }}</template>
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item>
                            <el-input
                              size="small"
                              v-model.trim="item.price"
                              :placeholder="
                                $t('rules.mustFill', [$t('material.price')])
                              "
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item v-if="item.inventoryId !== null">
                            <span class="mgr5">
                              库:{{ item._invQuantity }}{{ item.unit }}
                            </span>
                            <span>库存价:{{ item._invPrice | currency4 }}</span>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="5">
                      <el-input
                        type="textarea"
                        :rows="3"
                        :placeholder="$t('text.remark')"
                        v-model="item.remark"
                      ></el-input>
                    </el-col>
                  </el-row>
                </div>
                <div class="remove-order">
                  <el-button
                    type="text"
                    size="small"
                    @click="remove(index)"
                    v-if="index != 0"
                    >{{ $t("text.remove") }}</el-button
                  >
                </div>
              </div>
              <div class="center">
                <el-button
                  v-if="formObj.items.length < 10"
                  type="info"
                  @click="addMore"
                  plain
                  round
                  >{{ $t("action.addMore") }}</el-button
                >
                <span v-else class="orange">
                  {{ $t("prompt.addMorePrompt") }}
                </span>
              </div>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import BackButton from "@/components/BackButton";
import UploadSinglePicture from "@/components/UploadSinglePicture";
import SupplierMms from "@/api/supplierMms.js";
import InventoryMms from "@/api/inventoryMms.js";
import Material from "@/api/material.js";
import ReturnedMaterial from "@/api/returnedMaterial.js";

function bulid() {
  return {
    inventoryId: null,
    materialId: null,
    materialSerialNo: null,
    materialName: null,
    subjectId: null,
    subjectName: null,
    color: null,
    colorNo: null,
    unit: null,
    quantity: null,
    price: null,
    remark: null,
    _localRepeatFg: false,
    _supplierId: null,
    _supplierName: null,
    _invQuantity: null,
    _invPrice: null,
    _image: null,
  };
}

export default {
  mixins: [page],
  components: { UploadSinglePicture, BackButton },
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(
            this.$t("rules.required", [this.$t("returnedMaterial.serialNo")])
          )
        );
        return;
      }
      ReturnedMaterial.findBySerialNo({ serialNo: value.trim() }).then(
        function (res) {
          if (res.data.code === 200) {
            callback(
              new Error(
                self.$t("rules.exist", [self.$t("returnedMaterial.serialNo")])
              )
            );
          } else {
            callback();
          }
        }
      );
    };
    return {
      Util: Util,
      validateSerialNo: validateSerialNo,
      suppliers: [],
      invMaterials: [],
      formObj: {
        warehouseId: null,
        warehouseName: null,
        serialNo: Util.serialNo(),
        supplierId: null,
        supplierName: null,
        remark: null,
        items: [bulid(), bulid(), bulid()],
        returnedMaterialItems: [],
      },
      saveDoing: false,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.formObj.warehouseId = self.$route.params.warehouseId;
    self.formObj.warehouseName = self.$route.query.warehouseName;
    axios.all([SupplierMms.findByTenantId()]).then(
      axios.spread(function (suppliers) {
        if (suppliers.status === 200) {
          self.suppliers = suppliers.data;
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    querySearchSerialNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      InventoryMms.vagueFindBySerialNo({
        serialNo: queryString,
        warehouseId: self.formObj.warehouseId,
      }).then(function (res) {
        self.invMaterials = res.data;
        if (self.invMaterials.length !== 0) {
          for (const material of self.invMaterials) {
            Vue.set(material, "value", material.materialSerialNo);
          }
        }
        cb(self.invMaterials);
      });
    },
    handleSelectSerialNo(idx) {
      const self = this;
      self.formObj.items[idx]._localRepeatFg = false;
      const item = self.invMaterials.find(
        (p) => p.materialSerialNo === self.formObj.items[idx].materialSerialNo
      );
      if (
        self.Permit.currentUser().admin === true ||
        self.Permit.mmsAuthSubjuctIds().includes(item.material.subjectId)
      ) {
        self.formObj.items[idx].inventoryId = item.id;
        self.formObj.items[idx].materialId = item.materialId;
        self.formObj.items[idx].materialSerialNo = item.materialSerialNo;
        self.formObj.items[idx].materialName = item.material.name;
        self.formObj.items[idx].subjectId = item.material.subjectId;
        self.formObj.items[idx].subjectName = item.material.subjectName;
        self.formObj.items[idx].color = item.material.color;
        self.formObj.items[idx].colorNo = item.material.colorNo;
        self.formObj.items[idx].unit = item.material.unit;
        self.formObj.items[idx].quantity = null;
        self.formObj.items[idx].price = null;
        self.formObj.items[idx]._invQuantity = item.storeQuantity;
        self.formObj.items[idx]._invPrice = item.price;
        self.formObj.items[idx]._supplierId = item.material.supplierId;
        self.formObj.items[idx]._supplierName = item.material.supplierName;
        self.formObj.items[idx]._image = item.material.image;
        self.formObj.items[idx].remark = null;

        // 前台本地过滤
        const iis = self.formObj.items.filter(function (ii) {
          return (
            ii.materialSerialNo === self.formObj.items[idx].materialSerialNo
          );
        });
        if (iis.length > 1) {
          self.formObj.items[idx]._localRepeatFg = true;
          return;
        }
      } else {
        self.$message({
          message: self.$t("prompt.notManageSubject"),
          type: "warning",
        });
        self.formObj.items[idx].materialSerialNo = null;
      }
    },
    //===
    addMore() {
      this.formObj.items.push(bulid());
    },
    remove(index) {
      this.formObj.items.splice(index, 1);
    },
    //===
    saveSubmit() {
      const self = this;
      self.$refs.formObjForm.validate((valid) => {
        if (valid) {
          const items = JSON.parse(JSON.stringify(this.formObj.items)).filter(
            function (item) {
              return (
                item.materialSerialNo != null &&
                item.materialSerialNo != "" &&
                item.quantity != null &&
                item.quantity != "" &&
                item.price != null &&
                item.price != ""
              );
            }
          );
          if (items.length === 0) {
            self.$message({
              message: self.$t("prompt.atLeastOneDataFill"),
              type: "warning",
            });
            return;
          }
          const data = [];
          for (const item of items) {
            if (item._localRepeatFg === true) {
              self.$message({
                message: self.$t("prompt.errorMessage"),
                type: "warning",
              });
              return;
            }
            if (!Util.regexQuantity(item.price)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("material.price")]),
                type: "warning",
              });
              return;
            }
            if (!Util.regexQuantity(item.quantity)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("text.quantity")]),
                type: "warning",
              });
              return;
            }
            if (item.quantity > item._invQuantity) {
              self.$message({
                message: self.$t("prompt.existBeyondInvQty"),
                type: "warning",
              });
              return;
            }
          }
          self.formObj.returnedMaterialItems = items;
          self.formObj.supplierName = self.suppliers.find(
            (s) => s.id === self.formObj.supplierId
          ).name;
          self.saveDoing = true;
          ReturnedMaterial.create(self.formObj).then(function (res) {
            if (res.status === 200) {
              self.saveDoing = false;
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.$router.push({ name: "mmsReturns" });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>